/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import logoSvg from "../imgs/logo192.png";
import { Loading } from "../App";
import { T } from "./Translate";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Circle,
  useMap,
  ZoomControl,
} from "react-leaflet";
import { useNavigate } from "react-router-dom";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import {
  collection,
  onSnapshot,
  doc,
  updateDoc,
  serverTimestamp,
  addDoc,
  query,
  where,
  getDocs,
  getDoc,
  setDoc,
  deleteField,
} from "firebase/firestore";
import { auth, db } from "../firebase";
import { getSession, isLoggedIn } from "../session";
import { blockUser, unblockUser, fetchBlockedIds } from "../utils/blockedUsers";
import { canMessageUser } from "../utils/messaging";
import {
  CircularProgress,
  Box,
  Typography,
  Button,
  Avatar,
  Fab,
  Snackbar,
  Alert,
  Chip,
  Paper,
  Stack,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Badge,
  Divider,
  AvatarGroup,
  Rating,
  InputAdornment,
} from "@mui/material";
import {
  Person as PersonIcon,
  ArrowBack as ArrowBackIcon,
  MyLocation as MyLocationIcon,
  Refresh as RefreshIcon,
  AccountBox as AccountBoxIcon,
  GpsFixed as GpsFixedIcon,
  GpsNotFixed as GpsNotFixedIcon,
  MoodOutlined as MoodIcon,
  DirectionsWalk as WalkIcon,
  DirectionsRun as RunIcon,
  DirectionsBike as BikeIcon,
  Restaurant as RestaurantIcon,
  LocalCafe as CafeIcon,
  LocalBar as BarIcon,
  Park as ParkIcon,
  Notifications as NotificationsIcon,
  Close as CloseIcon,
  Send as SendIcon,
  Event as EventIcon,
  Group as GroupIcon,
  Chat as ChatIcon,
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Storefront as StorefrontIcon,
  LocationOn as LocationOnIcon,
  AccessTime as AccessTimeIcon,
  Search as SearchIcon,
} from "../icons";
import { brandColors } from "../theme";
import { alpha } from "@mui/material/styles";
import { getNextEventDate, formatEventDate } from "./eventsUtils";
import { safeHttpUrl, escapeHtml } from "../utils/safeUrl";

import SearchClearAdornment from "../components/SearchClearAdornment";
import MessagesClosedDialog from "../components/MessagesClosedDialog";
delete L.Icon.Default.prototype._getIconUrl;

// Radio de "Eventos cercanos" (mismo que usan las notificaciones de evento y
// tienda nueva cerca tuyo, ver functions/nearbyNotifications.js).
const NEARBY_RADIUS_KM = 10;

// Pin violeta con el ícono de calendario para los eventos (las tiendas usan
// el mismo pin en naranja).
const EVENT_MARKER_ICON = new L.DivIcon({
  html: `<div style="display:flex;flex-direction:column;align-items:center;filter:drop-shadow(0 4px 8px rgba(0,0,0,0.45));">
    <div style="background:linear-gradient(135deg,#6a1b9a 0%,#ab47bc 100%);width:44px;height:44px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid white;display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,0.4);">
      <svg style="transform:rotate(45deg);" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="white">
        <path d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"/>
      </svg>
    </div>
    <div style="width:8px;height:8px;background:#6a1b9a;border-radius:50%;margin-top:-2px;"></div>
  </div>`,
  className: "event-marker",
  iconSize: [44, 56],
  iconAnchor: [22, 56],
  popupAnchor: [0, -56],
});

// Estados de ánimo / actividades
const MOODS = [
  { icon: "😊", label: <T>Contento</T>, value: "happy" },
  { icon: "🎉", label: <T>Celebrando</T>, value: "party" },
  { icon: "🍔", label: <T>Comiendo</T>, value: "eating" },
  { icon: "🍦", label: <T>Helado</T>, value: "icecream" },
  { icon: "☕", label: <T>Café</T>, value: "coffee" },
  { icon: "🍺", label: <T>Bar</T>, value: "bar" },
  { icon: "🚶", label: <T>Paseando</T>, value: "walking" },
  { icon: "🏃", label: <T>Corriendo</T>, value: "running" },
  { icon: "🚴", label: <T>En bici</T>, value: "biking" },
  { icon: "🌳", label: <T>En el parque</T>, value: "park" },
  { icon: "🎵", label: <T>Escuchando música</T>, value: "music" },
  { icon: "📸", label: <T>Tomando fotos</T>, value: "photo" },
  { icon: "🛍️", label: <T>De compras</T>, value: "shopping" },
];

// Componente para centrar el mapa
const MapController = ({ center, shouldCenter }) => {
  const map = useMap();

  useEffect(() => {
    if (center && shouldCenter) {
      map.flyTo(center, 16, { duration: 1 });
    }
  }, [center, shouldCenter, map]);

  return null;
};

const UserMap = () => {
  const [messagesClosedOpen, setMessagesClosedOpen] = useState(false);
  const navigate = useNavigate();
  const mapRef = useRef(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [blockedIds, setBlockedIds] = useState([]);
  const [loading, setLoading] = useState(true);
  const [splash, setSplash] = useState(true);
  const [locationError, setLocationError] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [accuracy, setAccuracy] = useState(null);
  const [mapZoom, setMapZoom] = useState(6);
  const [gpsStatus, setGpsStatus] = useState("searching");
  const [shouldCenterMap, setShouldCenterMap] = useState(false);

  // Estados para actividad/mood
  const [openMoodDialog, setOpenMoodDialog] = useState(false);
  const [currentMood, setCurrentMood] = useState(null);
  const [statusMessage, setStatusMessage] = useState("");
  const [selectedMood, setSelectedMood] = useState("");

  // Controlar minimización del panel (siempre visible, mini o expandido)
  const [isMinimized, setIsMinimized] = useState(true);

  // Eventos cercanos
  const [nearbyEvents, setNearbyEvents] = useState([]);
  const [showEventsPanel, setShowEventsPanel] = useState(false);
  const [stores, setStores] = useState([]);
  const [showStoresPanel, setShowStoresPanel] = useState(false);

  // Estados de todos los usuarios (panel "Estados")
  const [statusUsers, setStatusUsers] = useState([]);
  const [showStatusSheet, setShowStatusSheet] = useState(false);

  // Buscador de amigos en el mapa
  const [showFriendSearch, setShowFriendSearch] = useState(false);
  const [friendSearchQuery, setFriendSearchQuery] = useState("");

  const updateIntervalRef = useRef(null);
  const isUpdatingRef = useRef(false);
  const hasInitialLocationRef = useRef(false);

  // Función para iniciar un chat directo
  const handleStartDirectChat = async (targetUserId) => {
    if (!auth.currentUser) {
      console.error("No hay usuario autenticado. Por favor, inicie sesión para enviar un mensaje.");
      return;
    }
    if (!targetUserId) {
      console.error("ID de usuario de destino no disponible.");
      return;
    }

    if (!(await canMessageUser(targetUserId, auth.currentUser.uid))) {
      setMessagesClosedOpen(true);
      return;
    }

    try {
      const currentUserId = auth.currentUser.uid;
      
      // Crear un ID consistente para la conversación (ordenar IDs alfabéticamente)
      const participantsSorted = [currentUserId, targetUserId].sort();
      const conversationId = `directo_${participantsSorted[0]}_${participantsSorted[1]}`;

      // Verificar si ya existe una conversación
      const conversationRef = doc(db, "conversations", conversationId);
      const conversationSnap = await getDoc(conversationRef);

      if (!conversationSnap.exists()) {
        // Crear nueva conversación directa
        await setDoc(conversationRef, {
          type: "directo",
          participants: participantsSorted,
          createdAt: serverTimestamp(),
          lastMessageTime: serverTimestamp(),
          unreadCount: {
            [currentUserId]: 0,
            [targetUserId]: 0,
          },
        });
      }

      // Navegar al chat
      navigate(`/chatbox/directo/${targetUserId}`);
    } catch (error) {
      console.error("Error creando chat directo:", error);
    }
  };

  // Actualizar ubicación y estado en Firestore
  const updateUserLocation = async (
    latitude,
    longitude,
    accuracy,
    moodToUse = null,
    messageToUse = null
  ) => {
    if (!currentUser?.uid || isUpdatingRef.current) return;

    isUpdatingRef.current = true;

    try {
      const userRef = doc(db, "users", currentUser.uid);
      // Cualquier usuario con sesión puede leer users/{uid} (ver
      // firestore.rules), así que con "Mostrar en el mapa" desactivado la
      // ubicación no se guarda (y se borra la anterior) en vez de solo
      // ocultarse en pantalla.
      const hideLocation = currentUser.mostrarEnMapa === false || currentUser.perfilPublico === false;
      const updateData = {
        latitude: hideLocation ? deleteField() : latitude,
        longitude: hideLocation ? deleteField() : longitude,
        accuracy: hideLocation ? deleteField() : accuracy || null,
        lastUpdated: serverTimestamp(),
        isActive: true,
      };

      // Usar el mood y mensaje proporcionados, o los del estado actual
      const finalMood = moodToUse !== null ? moodToUse : currentMood;
      const finalMessage = messageToUse !== null ? messageToUse : statusMessage;

      // Agregar mood/actividad si existe
      if (finalMood) {
        updateData.currentMood = finalMood;
        updateData.statusMessage = finalMessage || "";
      }

      await updateDoc(userRef, updateData);
    } catch (error) {
      console.error("❌ Error actualizando ubicación:", error);
    } finally {
      isUpdatingRef.current = false;
    }
  };

  // Marcar usuario como inactivo
  const markUserInactive = async () => {
    if (!currentUser?.uid || isUpdatingRef.current) return;

    isUpdatingRef.current = true;

    try {
      const userRef = doc(db, "users", currentUser.uid);
      await updateDoc(userRef, {
        isActive: false,
        lastUpdated: serverTimestamp(),
      });
    } catch (error) {
      console.error("❌ Error marcando inactivo:", error);
    } finally {
      isUpdatingRef.current = false;
    }
  };

  // Guardar mood/actividad
  const saveMoodStatus = async () => {
    if (!selectedMood || !currentUser?.uid) return;

    try {
      const userRef = doc(db, "users", currentUser.uid);

      // Actualizar en Firestore primero
      await updateDoc(userRef, {
        currentMood: selectedMood,
        statusMessage: statusMessage || "",
        moodUpdatedAt: serverTimestamp(),
      });

      // Actualizar estados locales después
      setCurrentMood(selectedMood);
      setOpenMoodDialog(false);

      // Actualizar la ubicación con el nuevo mood
      if (currentPosition) {
        // Pasar el mood y mensaje directamente para evitar problemas de sincronización
        await updateUserLocation(
          currentPosition[0],
          currentPosition[1],
          accuracy,
          selectedMood,
          statusMessage
        );
      }
    } catch (error) {
      console.error("Error guardando estado:", error);
    }
  };

  // Obtener ubicación GPS real del dispositivo
  const getCurrentLocation = () => {
    if (!navigator.geolocation) {
      setLocationError(<T>❌ Tu navegador no soporta geolocalización</T>);
      setGpsStatus("error");
      setLoading(false);
      return;
    }

    setGpsStatus("searching");

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const acc = Math.round(position.coords.accuracy);

        setCurrentPosition([lat, lng]);
        setAccuracy(acc);
        setGpsStatus("active");
        setLocationError(null);
        setLoading(false);

        // Centrar mapa solo la primera vez
        if (!hasInitialLocationRef.current) {
          hasInitialLocationRef.current = true;
          setMapZoom(16);
        }

        // Actualizar ubicación en Firestore
        if (currentUser) {
          updateUserLocation(lat, lng, acc);
        }
      },
      (error) => {
        console.error("❌ Error obteniendo ubicación:", error);
        let errorMessage = <T>❌ Error al obtener ubicación GPS</T>;

        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = <T>❌ Permiso de ubicación denegado</T>;
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = <T>❌ Ubicación no disponible</T>;
            break;
          case error.TIMEOUT:
            errorMessage = <T>❌ Tiempo de espera agotado</T>;
            break;
          default:
            errorMessage = <T>❌ Error: {error.message}</T>;
        }

        setLocationError(errorMessage);
        setGpsStatus("error");
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  };

  // Obtener emoji del mood
  const getMoodEmoji = (moodValue) => {
    const mood = MOODS.find((m) => m.value === moodValue);
    return mood ? mood.icon : "😊";
  };

  // Formatear distancia
  const formatDistance = (distance) => {
    if (distance < 1) {
      return `${Math.round(distance * 1000)}m`;
    }
    return `${distance.toFixed(1)}km`;
  };

  // Formatear tiempo relativo (para el panel de Estados)
  const formatRelativeTime = (date) => {
    if (!date) return "";
    const diffSec = Math.floor((Date.now() - date.getTime()) / 1000);
    if (diffSec < 60) return <T>ahora</T>;
    const diffMin = Math.floor(diffSec / 60);
    if (diffMin < 60) return <T>hace {diffMin}m</T>;
    const diffHr = Math.floor(diffMin / 60);
    if (diffHr < 24) return <T>hace {diffHr}h</T>;
    const diffDay = Math.floor(diffHr / 24);
    return <T>hace {diffDay}d</T>;
  };

  // Centra el mapa en la ubicación de un usuario (usado al tocar un estado)
  const flyToLocation = (latitude, longitude) => {
    if (!latitude || !longitude || !mapRef.current) return;
    mapRef.current.flyTo([latitude, longitude], 16, { duration: 1 });
  };

  // Calcular distancia entre dos puntos
  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371; // Radio de la Tierra en km
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  };

  // Cargar usuarios bloqueados (para no mostrarlos en el mapa)
  useEffect(() => {
    if (!currentUser?.uid) {
      setBlockedIds([]);
      return;
    }
    fetchBlockedIds(currentUser.uid).then(setBlockedIds);
  }, [currentUser?.uid]);

  const handleBlockMapUser = async (targetUserId) => {
    if (!currentUser?.uid || !targetUserId) return;
    await blockUser(currentUser.uid, targetUserId);
    setBlockedIds((prev) => (prev.includes(targetUserId) ? prev : [...prev, targetUserId]));
  };

  // Cargar tiendas
  useEffect(() => {
    getDocs(collection(db, "stores")).then((snap) =>
      setStores(snap.docs.map((d) => ({ id: d.id, ...d.data() })))
    );
  }, []);

  // Buscar eventos cercanos
  const fetchNearbyEvents = async (lat, lon) => {
    if (!lat || !lon) return;

    try {
      // Solo públicos (las reglas no dejan listar eventos privados ajenos).
      const eventsRef = query(collection(db, "events"), where("isPrivate", "==", false));
      const eventsSnapshot = await getDocs(eventsRef);

      const nearEvents = [];
      eventsSnapshot.forEach((doc) => {
        const eventData = doc.data();
        if (eventData.latitude && eventData.longitude) {
          const distance = calculateDistance(
            lat,
            lon,
            eventData.latitude,
            eventData.longitude
          );

          // Solo los que tienen una fecha que todavía no pasó.
          const nextDate = getNextEventDate(eventData);
          if (distance <= NEARBY_RADIUS_KM && nextDate) {
            nearEvents.push({
              id: doc.id,
              ...eventData,
              distance: distance,
              nextDate,
            });
          }
        }
      });

      nearEvents.sort((a, b) => a.distance - b.distance);
      setNearbyEvents(nearEvents);
    } catch (error) {
      console.error("Error buscando eventos cercanos:", error);
    }
  };

  // Inicializar usuario actual y escuchar cambios en tiempo real
  useEffect(() => {
    let unsubscribeUser = null;
    const initUser = async () => {
      try {
        // Intentar obtener sesión con múltiples métodos
        let session = await getSession();

        // Si getSession falla, intentar con auth.currentUser directamente
        if (!session || !session.user) {
          // Esperar un momento por si auth está inicializándose
          await new Promise(resolve => setTimeout(resolve, 1000));

          if (auth.currentUser) {
            session = { user: auth.currentUser };
          } else {
            navigate("/login");
            return;
          }
        }

        const userRef = doc(db, "users", session.user.uid);

        // Listener en tiempo real para el usuario en sesión
        unsubscribeUser = onSnapshot(userRef, (userSnap) => {
          if (userSnap.exists()) {
            const userData = userSnap.data();
            setCurrentUser({
              uid: session.user.uid,
              ...userData,
            });
            // Restaurar mood si existe
            if (userData.currentMood) {
              setCurrentMood(userData.currentMood);
              setStatusMessage(userData.statusMessage || "");
            }
          } else {
            console.warn("⚠️ Usuario autenticado pero sin documento en Firestore");
            setCurrentUser({
              uid: session.user.uid,
              displayName: session.user.displayName || "Usuario",
              email: session.user.email,
            });
          }
        });

        getCurrentLocation();
      } catch (error) {
        console.error("Error inicializando usuario:", error);
        // Solo redirigir si el error es de autenticación
        if (error.code === 'auth/user-not-found' || error.code === 'permission-denied') {
          navigate("/login");
        }
      }
    };

    // Show splash for at least 1 second
    const splashTimeout = setTimeout(() => setSplash(false), 1000);
    initUser();

    return () => {
      if (updateIntervalRef.current) {
        clearInterval(updateIntervalRef.current);
      }
      markUserInactive();
      if (unsubscribeUser) {
        unsubscribeUser();
      }
      clearTimeout(splashTimeout);
    };
  }, [navigate]);

  // Actualizar ubicación periódicamente
  useEffect(() => {
    if (!currentUser || !currentPosition) return;

    updateIntervalRef.current = setInterval(() => {
      getCurrentLocation();
    }, 30000); // Actualizar cada 30 segundos

    return () => {
      if (updateIntervalRef.current) {
        clearInterval(updateIntervalRef.current);
      }
    };
  }, [currentUser, currentPosition]);

  // Escuchar otros usuarios en tiempo real
  useEffect(() => {
    if (!currentUser || !currentPosition) return;

    const usersRef = collection(db, "users");
    const usersQuery = query(usersRef, where("isActive", "==", true));

    const unsubscribe = onSnapshot(usersQuery, (snapshot) => {
      const usersData = [];
      snapshot.forEach((doc) => {
        if (doc.id !== currentUser.uid) {
          const userData = doc.data();
          // "Perfil público" y "Mostrar mi estado en el mapa" (ajustes de
          // privacidad) prometen ambos que el usuario deja de aparecer en el
          // mapa si se desactivan — antes ningún campo se chequeaba acá.
          if (userData.perfilPublico === false || userData.mostrarEnMapa === false) {
            return;
          }
          if (userData.latitude && userData.longitude) {
            const distance = calculateDistance(
              currentPosition[0],
              currentPosition[1],
              userData.latitude,
              userData.longitude
            );

            usersData.push({
              id: doc.id,
              ...userData,
              distance: distance,
              lastUpdated: userData.lastUpdated?.toDate(),
            });
          }
        }
      });

      // Ordenar por distancia
      usersData.sort((a, b) => a.distance - b.distance);
      setUsers(usersData);
    });

    return () => unsubscribe();
  }, [currentUser, currentPosition]);

  // Buscar eventos cercanos cuando cambia la posición
  useEffect(() => {
    if (currentPosition) {
      fetchNearbyEvents(currentPosition[0], currentPosition[1]);
    }
  }, [currentPosition]);

  // Escuchar los estados (mood) de todos los usuarios, activos o no
  // (a diferencia del listener de "usuarios cerca", este no filtra por
  // isActive/ubicación: un estado publicado hace días sigue apareciendo
  // en el panel "Estados").
  useEffect(() => {
    const usersRef = collection(db, "users");
    const unsubscribe = onSnapshot(usersRef, (snapshot) => {
      const list = [];
      snapshot.forEach((docSnap) => {
        const data = docSnap.data();
        if (data.currentMood) {
          list.push({
            id: docSnap.id,
            displayName: data.displayName || "Usuario",
            profileImageUrl: data.profileImageUrl || "",
            currentMood: data.currentMood,
            statusMessage: data.statusMessage || "",
            moodUpdatedAt: data.moodUpdatedAt?.toDate ? data.moodUpdatedAt.toDate() : null,
            latitude: data.latitude || null,
            longitude: data.longitude || null,
          });
        }
      });
      list.sort((a, b) => {
        if (currentUser && a.id === currentUser.uid) return -1;
        if (currentUser && b.id === currentUser.uid) return 1;
        return (b.moodUpdatedAt || 0) - (a.moodUpdatedAt || 0);
      });
      setStatusUsers(list);
    });
    return () => unsubscribe();
  }, [currentUser?.uid]);

  if (loading || splash) {
    return <Loading />;
  }

  if (!currentPosition) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: 2,
          p: 3,
        }}
      >
        <Typography variant="h5" color="error" gutterBottom>
          {locationError || <T>No se pudo obtener tu ubicación</T>}
        </Typography>
        <Button
          variant="contained"
          size="large"
          startIcon={<RefreshIcon />}
          onClick={getCurrentLocation}
        >
          <T>Intentar nuevamente</T>
        </Button>
      </Box>
    );
  }

  if (loading) {
    return <Loading />;
  }

  return (

    <Box sx={{ height: "100vh", position: "relative" }}>
      {/* Botón de retroceso */}
      <Fab
        color="primary"
        size="medium"
        sx={{
          position: "absolute",
          bottom: 80,
          left: 16,
          zIndex: 1000,
        }}
        onClick={() => navigate(-1)}
      >
        <Tooltip title={<T>Volver atrás</T>} placement="right">
          <ArrowBackIcon />
        </Tooltip>
      </Fab>

      {/* Panel de información superior - Con opción de minimizar */}
      <Paper
          onClick={() => {
            if (isMinimized) setIsMinimized(false);
          }}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            maxWidth: "980px",
            mx: "auto",
            zIndex: 1000,
            p: isMinimized ? 1.5 : 2,
            pb: 1,
            borderRadius: 0,
            borderBottomLeftRadius: 16,
            borderBottomRightRadius: 16,
            backdropFilter: "blur(10px)",
            bgcolor: alpha(brandColors.backgroundPaper, 0.97),
            boxShadow: 3,
            transition: "all 0.3s ease",
            cursor: isMinimized ? "pointer" : "default",
          }}
        >
          <Box
            onClick={() => setIsMinimized(!isMinimized)}
            sx={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              mb: isMinimized ? 0 : 1,
              cursor: "pointer",
            }}
          >
            <Typography
              variant={isMinimized ? "body1" : "h6"}
              fontWeight="bold"
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              {isMinimized ? <T>Mapa</T> : <T>Mapa de Usuarios</T>}
            </Typography>
            <Box sx={{ ml: "auto" }}>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMinimized(!isMinimized);
                }}
                sx={{ mr: 0.5 }}
              >
                {isMinimized ? (
                  <Tooltip title={<T>Expandir</T>}>
                    <ExpandMoreIcon fontSize="small" />
                  </Tooltip>
                ) : (
                  <Tooltip title={<T>Minimizar</T>}>
                    <ExpandLessIcon fontSize="small" />
                  </Tooltip>
                )}
              </IconButton>
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsMinimized(true);
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
          </Box>

          {/* Vista minimizada */}
          {isMinimized ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
              <Avatar
                src={currentUser?.profileImageUrl}
                sx={{ width: 32, height: 32 }}
              >
                <PersonIcon />
              </Avatar>
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="caption" fontWeight="bold" display="block">
                  {currentUser?.displayName || <T>Usuario</T>}
                </Typography>
                {currentMood && (
                  <Typography variant="caption" sx={{ color: brandColors.textPrimary }}>
                    {getMoodEmoji(currentMood)} {MOODS.find((m) => m.value === currentMood)?.label}
                  </Typography>
                )}
              </Box>
              <Chip 
                label={users.length} 
                size="small" 
                color="primary" 
                sx={{ height: 20 }}
              />
            </Box>
          ) : (
            /* Vista expandida */
            <>
              <Divider sx={{ my: 1 }} />

              {currentUser && (
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <Avatar
                      src={currentUser.profileImageUrl}
                      sx={{ width: 40, height: 40 }}
                    >
                      <PersonIcon />
                    </Avatar>
                    <Box>
                      <Typography variant="body2" fontWeight="bold">
                        {currentUser.displayName || <T>Usuario</T>}
                      </Typography>
                      <Chip
                        label={gpsStatus === "active" ? <T>🟢 En línea</T> : <T>🔍 Buscando GPS</T>}
                        size="small"
                        color={gpsStatus === "active" ? "success" : "warning"}
                      />
                    </Box>
                  </Box>

                  {currentMood ? (
                    <Paper
                      sx={{
                        p: 1.5,
                        bgcolor: brandColors.primary,
                        color: "white",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setOpenMoodDialog(true);
                        setSelectedMood(currentMood);
                      }}
                    >
                      <Typography variant="body2" fontWeight="bold" sx={{ color: "white" }}>
                        {getMoodEmoji(currentMood)}{" "}
                        {MOODS.find((m) => m.value === currentMood)?.label}
                      </Typography>
                      {statusMessage && (
                        <Typography variant="caption" sx={{ fontStyle: "italic", color: "white" }}>
                          "{statusMessage}"
                        </Typography>
                      )}
                    </Paper>
                  ) : (
                    <Button
                      fullWidth
                      variant="outlined"
                      startIcon={<MoodIcon />}
                      onClick={() => {
                        setOpenMoodDialog(true);
                      }}
                      sx={{ mt: 1 }}
                    >
                      <T>¿Qué estás haciendo?</T>
                    </Button>
                  )}
                </Box>
              )}

              <Divider sx={{ my: 1 }} />

              <Stack spacing={1}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="body2" color="text.secondary">
                    <T>Usuarios cerca:</T>
                  </Typography>
                  <Chip label={users.length} size="small" color="primary" />
                </Box>

                {accuracy && (
                  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="body2" color="text.secondary">
                      <T>Precisión GPS:</T>
                    </Typography>
                    <Chip
                      label={`±${accuracy}m`}
                      size="small"
                      color={accuracy < 50 ? "success" : "warning"}
                    />
                  </Box>
                )}

                <Box
                  onClick={() => {
                    setShowStoresPanel(false);
                    setShowStatusSheet(false);
                    setShowEventsPanel((v) => !v);
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mx: -1,
                    px: 1,
                    py: 0.25,
                    borderRadius: 1,
                    cursor: "pointer",
                    "&:hover": { bgcolor: alpha(brandColors.textPrimary, 0.08) },
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    <T>Eventos cercanos:</T>
                  </Typography>
                  <Chip
                    icon={<EventIcon sx={{ fontSize: 14 }} />}
                    label={nearbyEvents.length}
                    size="small"
                    color="primary"
                  />
                </Box>
                <Box
                  onClick={() => {
                    setShowEventsPanel(false);
                    setShowStatusSheet(false);
                    setShowStoresPanel((v) => !v);
                  }}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mx: -1,
                    px: 1,
                    py: 0.25,
                    borderRadius: 1,
                    cursor: "pointer",
                    "&:hover": { bgcolor: alpha(brandColors.textPrimary, 0.08) },
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    <T>Tiendas:</T>
                  </Typography>
                  <Chip
                    icon={<StorefrontIcon sx={{ fontSize: 14 }} />}
                    label={stores.length}
                    size="small"
                    color="primary"
                  />
                </Box>
              </Stack>
            </>
          )}

          <Box
            onClick={(e) => {
              e.stopPropagation();
              setIsMinimized(!isMinimized);
            }}
            sx={{ display: "flex", justifyContent: "center", pt: isMinimized ? 1 : 1.5, cursor: "pointer" }}
          >
            <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: alpha(brandColors.textPrimary, 0.3) }} />
          </Box>
      </Paper>

      {/* Buscador de amigos - filtra la lista de usuarios visibles en el
          mapa por nombre y, al elegir uno, centra el mapa en su ubicación. */}
      {showFriendSearch && (() => {
        const visibleUsers = users.filter((u) => !blockedIds.includes(u.id));
        const query = friendSearchQuery.trim().toLowerCase();
        const results = query
          ? visibleUsers.filter((u) => (u.displayName || "").toLowerCase().includes(query))
          : visibleUsers;
        return (
          <Paper
            sx={{
              position: "absolute",
              top: 16,
              left: 16,
              right: 16,
              maxWidth: "980px",
              mx: "auto",
              zIndex: 1300,
              p: 1.5,
              borderRadius: 3,
              backdropFilter: "blur(10px)",
              bgcolor: alpha(brandColors.backgroundPaper, 0.97),
              maxHeight: "70vh",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                autoFocus
                fullWidth
                size="small"
                variant="outlined"
                placeholder="Buscar un amigo por nombre..."
                value={friendSearchQuery}
                onChange={(e) => setFriendSearchQuery(e.target.value)}
                InputProps={{
                  endAdornment: <SearchClearAdornment value={friendSearchQuery} onChange={(e) => setFriendSearchQuery(e.target.value)} />,
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" />
                    </InputAdornment>
                  ),
                }}
              />
              <IconButton
                size="small"
                onClick={() => {
                  setShowFriendSearch(false);
                  setFriendSearchQuery("");
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ overflowY: "auto", mt: 1 }}>
              {results.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
                  {query ? <T>No se encontraron amigos con ese nombre</T> : <T>No hay usuarios cerca para mostrar</T>}
                </Typography>
              ) : (
                <Stack spacing={0.5}>
                  {results.map((u) => (
                    <Box
                      key={u.id}
                      onClick={() => {
                        flyToLocation(u.latitude, u.longitude);
                        setShowFriendSearch(false);
                        setFriendSearchQuery("");
                      }}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        p: 1,
                        borderRadius: 1.5,
                        cursor: "pointer",
                        "&:hover": { bgcolor: alpha(brandColors.textPrimary, 0.06) },
                      }}
                    >
                      <Avatar src={u.profileImageUrl} sx={{ width: 36, height: 36 }}>
                        <PersonIcon fontSize="small" />
                      </Avatar>
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="body2" fontWeight="bold" noWrap>
                          {u.displayName || <T>Usuario</T>}
                        </Typography>
                        {u.currentMood && (
                          <Typography variant="caption" color="text.secondary" noWrap display="block">
                            {getMoodEmoji(u.currentMood)} {MOODS.find((m) => m.value === u.currentMood)?.label}
                          </Typography>
                        )}
                      </Box>
                      <Chip label={formatDistance(u.distance)} size="small" variant="outlined" />
                    </Box>
                  ))}
                </Stack>
              )}
            </Box>
          </Paper>
        );
      })()}

      {/* Panel "Estados" - lista de estados/mood de todos los usuarios */}
      <Paper
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          bottom: 0,
          maxWidth: "980px",
          mx: "auto",
          zIndex: 1100,
          bgcolor: alpha(brandColors.backgroundPaper, 0.97),
          backdropFilter: "blur(10px)",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          display: "flex",
          flexDirection: "column",
          maxHeight: showStatusSheet ? "45vh" : "auto",
        }}
      >
        <Box
          onClick={() => {
            setShowEventsPanel(false);
            setShowStoresPanel(false);
            setShowStatusSheet((v) => !v);
          }}
          sx={{
            display: "flex",
            alignItems: "center",
            position: "relative",
            px: 2,
            py: 1.5,
            cursor: "pointer",
          }}
        >
          <Typography
            component="div"
            variant="body1"
            fontWeight="bold"
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translateX(-50%)",
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <T>Estados</T>
            <Chip label={statusUsers.length} size="small" color="primary" sx={{ height: 20 }} />
          </Typography>
          <IconButton size="small" sx={{ ml: "auto" }}>
            {showStatusSheet ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
        </Box>

        {showStatusSheet && (
          <>
            <Box sx={{ display: "flex", justifyContent: "center", pb: 1 }}>
              <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: alpha(brandColors.textPrimary, 0.3) }} />
            </Box>
            <Divider />
            <Box sx={{ overflowY: "auto", px: 2, py: 1 }}>
              {statusUsers.length === 0 ? (
                <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
                  <T>Nadie compartió un estado todavía</T>
                </Typography>
              ) : (
                <Stack spacing={1.5} sx={{ py: 1 }}>
                  {statusUsers.map((u) => {
                    const isSelf = currentUser && u.id === currentUser.uid;
                    const moodDef = MOODS.find((m) => m.value === u.currentMood);
                    const hasLocation = !!(u.latitude && u.longitude);
                    return (
                      <Box
                        key={u.id}
                        onClick={() => hasLocation && flyToLocation(u.latitude, u.longitude)}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 1.5,
                          cursor: hasLocation ? "pointer" : "default",
                        }}
                      >
                        <Avatar
                          src={isSelf ? currentUser.profileImageUrl || logoSvg : u.profileImageUrl}
                          sx={{ width: 36, height: 36 }}
                        >
                          <PersonIcon fontSize="small" />
                        </Avatar>
                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Typography variant="body2" fontWeight="bold" noWrap>
                            {u.displayName} {isSelf && <T>(Tú)</T>}
                          </Typography>
                          <Typography variant="caption" color="text.secondary" noWrap display="block">
                            {getMoodEmoji(u.currentMood)} {moodDef?.label}
                            {u.statusMessage && <> - "{u.statusMessage}"</>}
                          </Typography>
                        </Box>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{ whiteSpace: "nowrap", pt: 0.3 }}
                        >
                          {formatRelativeTime(u.moodUpdatedAt)}
                        </Typography>
                      </Box>
                    );
                  })}
                </Stack>
              )}
            </Box>
          </>
        )}
      </Paper>

      {/* Panel de tiendas - bottom sheet a todo el ancho (mismo patrón que
          "Estados"), para que se lea bien con muchos resultados y no quede
          flotando en una cajita chica que se corta o se superpone con otros
          paneles. */}
      {showStoresPanel && (
        <Paper
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            maxWidth: "980px",
            mx: "auto",
            zIndex: 1100,
            bgcolor: alpha(brandColors.backgroundPaper, 0.97),
            backdropFilter: "blur(10px)",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            display: "flex",
            flexDirection: "column",
            maxHeight: "55vh",
          }}
        >
          <Box
            onClick={() => setShowStoresPanel(false)}
            sx={{ display: "flex", alignItems: "center", position: "relative", px: 2, py: 1.5, cursor: "pointer" }}
          >
            <Typography
              component="div"
              variant="body1"
              fontWeight="bold"
              sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)", display: "flex", alignItems: "center", gap: 1 }}
            >
              <StorefrontIcon fontSize="small" />
              <T>Tiendas</T>
              <Chip label={stores.length} size="small" color="primary" sx={{ height: 20 }} />
            </Typography>
            <IconButton size="small" sx={{ ml: "auto" }}>
              <ExpandLessIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", pb: 1, cursor: "pointer" }} onClick={() => setShowStoresPanel(false)}>
            <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: alpha(brandColors.textPrimary, 0.3) }} />
          </Box>
          <Divider />
          <Box sx={{ overflowY: "auto", px: 2, py: 1 }}>
            {stores.length === 0 ? (
              <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
                <T>No hay tiendas disponibles</T>
              </Typography>
            ) : (
              <Stack spacing={1.5} sx={{ py: 1 }}>
                {stores.map((store) => (
                  <Paper
                    key={store.id}
                    sx={{ p: 1.5, bgcolor: brandColors.backgroundDefault, cursor: store.latitude && store.longitude ? "pointer" : "default" }}
                    onClick={() => {
                      if (!store.latitude || !store.longitude) return;
                      flyToLocation(store.latitude, store.longitude);
                      setShowStoresPanel(false);
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <StorefrontIcon sx={{ color: brandColors.textPrimary }} fontSize="small" />
                      <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Typography variant="subtitle2" fontWeight="bold" noWrap>
                          {store.name || store.storeName}
                        </Typography>
                        {store.description && (
                          <Typography variant="caption" color="text.secondary" noWrap display="block">
                            {store.description}
                          </Typography>
                        )}
                        {!!store.ratingCount && (
                          <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5 }}>
                            <Rating value={store.avgRating || 0} precision={0.1} readOnly size="small" />
                            <Typography variant="caption" color="text.secondary">
                              {(store.avgRating || 0).toFixed(1)} ({store.ratingCount})
                            </Typography>
                          </Stack>
                        )}
                        <Chip label={store.slug} size="small" variant="outlined" sx={{ mt: 0.5 }} />
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Stack>
            )}
          </Box>
        </Paper>
      )}

      {/* Panel de eventos - mismo patrón bottom sheet que Tiendas/Estados */}
      {showEventsPanel && (
        <Paper
          sx={{
            position: "absolute",
            left: 0,
            right: 0,
            bottom: 0,
            maxWidth: "980px",
            mx: "auto",
            zIndex: 1100,
            bgcolor: alpha(brandColors.backgroundPaper, 0.97),
            backdropFilter: "blur(10px)",
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            display: "flex",
            flexDirection: "column",
            maxHeight: "55vh",
          }}
        >
          <Box
            onClick={() => setShowEventsPanel(false)}
            sx={{ display: "flex", alignItems: "center", position: "relative", px: 2, py: 1.5, cursor: "pointer" }}
          >
            <Typography
              component="div"
              variant="body1"
              fontWeight="bold"
              sx={{ position: "absolute", left: "50%", transform: "translateX(-50%)", display: "flex", alignItems: "center", gap: 1 }}
            >
              <EventIcon fontSize="small" /> <T>Eventos Cercanos</T>
              <Chip label={nearbyEvents.length} size="small" color="primary" sx={{ height: 20 }} />
            </Typography>
            <IconButton size="small" sx={{ ml: "auto" }}>
              <ExpandLessIcon fontSize="small" />
            </IconButton>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", pb: 1, cursor: "pointer" }} onClick={() => setShowEventsPanel(false)}>
            <Box sx={{ width: 36, height: 4, borderRadius: 2, bgcolor: alpha(brandColors.textPrimary, 0.3) }} />
          </Box>
          <Divider />
          <Box sx={{ overflowY: "auto", px: 2, py: 1 }}>
            {nearbyEvents.length === 0 ? (
              <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: "center" }}>
                <T>No hay eventos cercanos</T>
              </Typography>
            ) : (
              <Stack spacing={1.5} sx={{ py: 1 }}>
                {nearbyEvents.map((event) => (
                  <Paper
                    key={event.id}
                    sx={{ p: 1.5, bgcolor: brandColors.backgroundDefault, cursor: event.latitude && event.longitude ? "pointer" : "default" }}
                    onClick={() => {
                      if (!event.latitude || !event.longitude) return;
                      flyToLocation(event.latitude, event.longitude);
                      setShowEventsPanel(false);
                    }}
                  >
                    <Typography variant="subtitle2" fontWeight="bold">
                      {event.title || <T>Sin título</T>}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      <T>📍 A {formatDistance(event.distance)} de ti</T>
                    </Typography>
                    <Typography variant="caption" display="block">
                      📅 {formatEventDate(event.nextDate)}
                    </Typography>
                  </Paper>
                ))}
              </Stack>
            )}
          </Box>
        </Paper>
      )}

      {/* Botones de acción flotantes. Van encima de la burbuja del asistente
          (SupportAssistantWidget: fixed, bottom 70, 56px de alto). */}
      <Stack
        spacing={2}
        sx={{
          position: "absolute",
          bottom: 142,
          right: 16,
          zIndex: 1000,
        }}
      >
        <Tooltip title={<T>Buscar un amigo</T>} placement="left">
          <Fab
            color="primary"
            size="medium"
            onClick={() => setShowFriendSearch((v) => !v)}
          >
            <SearchIcon />
          </Fab>
        </Tooltip>

        <Tooltip title={<T>Centrar mapa en mi ubicación</T>} placement="left">
          <Fab
            color="primary"
            size="medium"
            onClick={() => {
              setShouldCenterMap(true);
              setMapZoom(16);
            }}
          >
            <MyLocationIcon />
          </Fab>
        </Tooltip>

        <Tooltip title={<T>Actualizar ubicación</T>} placement="left">
          <Fab
            color="primary"
            size="medium"
            onClick={getCurrentLocation}
          >
            <RefreshIcon />
          </Fab>
        </Tooltip>

        <Tooltip title={<T>Mi perfil</T>} placement="left">
          <Fab
            color="primary"
            size="medium"
            onClick={() => navigate(`/user/${currentUser?.uid}`)}
          >
            <AccountBoxIcon />
          </Fab>
        </Tooltip>
      </Stack>

      {/* Mapa */}
      <MapContainer
        ref={mapRef}
        center={currentPosition}
        zoom={mapZoom}
        style={{ height: "100%", width: "100%" }}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* El control de zoom default queda en "topleft", justo debajo del
            panel "Mapa de Usuarios" (Paper absolute top:0), tapándose con él
            en mobile. Se mueve a "bottomleft" (abajo del botón "Volver
            atrás", que está en bottom:80) donde no choca con nada. */}
        <ZoomControl position="bottomleft" />

        <MapController center={currentPosition} shouldCenter={shouldCenterMap} />

        {/* Marcador del usuario actual */}
        {currentPosition && (
          <>
            <Circle
              center={currentPosition}
              radius={accuracy || 50}
              pathOptions={{
                fillColor: "#2196F3",
                fillOpacity: 0.15,
                color: "#2196F3",
                weight: 2,
              }}
            />

            <Marker
              position={currentPosition}
              icon={
                new L.DivIcon({
                  html: `
                  <div style="
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    width: 38px;
                    height: 38px;
                    border-radius: 50%;
                    border: 4px solid white;
                    box-shadow: 0 3px 10px rgba(0,0,0,0.4);
                    position: relative;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                    ${
                      safeHttpUrl(currentUser?.profileImageUrl)
                        ? `<img src="${escapeHtml(safeHttpUrl(currentUser.profileImageUrl))}" alt="perfil" style="width:100%;height:100%;object-fit:cover;border-radius:50%;" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';" /><div style="display:none;width:100%;height:100%;align-items:center;justify-content:center;"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg></div>`
                        : '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
                    }
                    ${
                      currentMood
                        ? `<div style="
                      position: absolute;
                      top: -28px;
                      left: 50%;
                      transform: translateX(-50%);
                      font-size: 22px;
                      filter: drop-shadow(0 2px 3px rgba(0,0,0,0.4));
                    ">${getMoodEmoji(currentMood)}</div>`
                        : ""
                    }
                  </div>
                `,
                  className: "current-user-marker",
                  iconSize: [38, 38],
                  iconAnchor: [19, 19],
                  popupAnchor: [0, -19],
                })
              }
            >
              <Popup>
                <Box sx={{ textAlign: "center", p: 1, minWidth: 200 }}>
                  <Avatar
                    src={currentUser?.profileImageUrl}
                    sx={{
                      width: 60,
                      height: 60,
                      margin: "0 auto 8px",
                      border: 3,
                      borderColor: "primary.main",
                    }}
                  >
                    <PersonIcon sx={{ fontSize: 35 }} />
                  </Avatar>
                  <Typography variant="h6" fontWeight="bold">
                    {currentUser?.displayName || <T>Tú</T>}
                  </Typography>
                  <Chip icon={<LocationOnIcon />} label={<T>Tu ubicación</T>} color="primary" size="small" sx={{ my: 1 }} />

                  {currentMood && (
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      {getMoodEmoji(currentMood)}{" "}
                      {MOODS.find((m) => m.value === currentMood)?.label}
                    </Typography>
                  )}
                  
                  {statusMessage && (
                    <Typography
                      variant="caption"
                      display="block"
                      color="text.secondary"
                      sx={{ mt: 1, fontStyle: "italic" }}
                    >
                      "{statusMessage}"
                    </Typography>
                  )}

                  <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
                    <Button
                      variant="outlined"
                      size="small"
                      fullWidth
                      startIcon={<MoodIcon />}
                      onClick={() => setOpenMoodDialog(true)}
                    >
                      <T>Cambiar Estado</T>
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      onClick={() => navigate(`/user/${currentUser?.uid}`)}
                    >
                      <T>Ver Perfil</T>
                    </Button>
                  </Stack>
                </Box>
              </Popup>
            </Marker>
          </>
        )}

        {/* Marcadores de tiendas */}
        {stores
          .filter((store) => store.latitude && store.longitude)
          .map((store) => (
            <Marker
              key={`store-${store.id}`}
              position={[store.latitude, store.longitude]}
              icon={
                new L.DivIcon({
                  html: `<div style="
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.45));
                  ">
                    <div style="
                      background: linear-gradient(135deg, #e65100 0%, #ff8f00 100%);
                      width: 44px;
                      height: 44px;
                      border-radius: 50% 50% 50% 0;
                      transform: rotate(-45deg);
                      border: 3px solid white;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      box-shadow: 0 2px 6px rgba(0,0,0,0.4);
                    ">
                      <svg style="transform:rotate(45deg);" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
                        <path d="M20 4H4v2l16-.01V4zm1 5H3l1 9h16l1-9zm-9 7H8v-2h4v2zm2-4H8v-2h6v2z"/>
                      </svg>
                    </div>
                    <div style="
                      width: 8px;
                      height: 8px;
                      background: #e65100;
                      border-radius: 50%;
                      margin-top: -2px;
                    "></div>
                  </div>`,
                  className: "store-marker",
                  iconSize: [44, 56],
                  iconAnchor: [22, 56],
                  popupAnchor: [0, -56],
                })
              }
            >
              <Popup>
                <Box sx={{ p: 1, minWidth: 200 }}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                    <StorefrontIcon color="warning" />
                    <Typography variant="subtitle1" fontWeight="bold">
                      {store.name || store.storeName}
                    </Typography>
                  </Box>
                  {!!store.ratingCount && (
                    <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mb: 1 }}>
                      <Rating value={store.avgRating || 0} precision={0.1} readOnly size="small" />
                      <Typography variant="caption" color="text.secondary">
                        {(store.avgRating || 0).toFixed(1)} ({store.ratingCount})
                      </Typography>
                    </Stack>
                  )}
                  {store.description && (
                    <Typography variant="body2" sx={{ mb: 1 }}>
                      {store.description}
                    </Typography>
                  )}
                  {store.address && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                      <LocationOnIcon sx={{ fontSize: 14 }} color="action" />
                      <Typography variant="caption">{store.address}</Typography>
                    </Box>
                  )}
                  {store.hours && (
                    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5, mb: 1 }}>
                      <AccessTimeIcon sx={{ fontSize: 14, mt: "2px" }} color="action" />
                      <Typography variant="caption" sx={{ whiteSpace: "pre-line" }}>{store.hours}</Typography>
                    </Box>
                  )}
                  <Stack direction="row" spacing={1}>
                    {store.ownerId && store.ownerId !== auth.currentUser?.uid && (
                      <Button
                        variant="outlined"
                        size="small"
                        fullWidth
                        color="warning"
                        startIcon={<ChatIcon />}
                        onClick={() => handleStartDirectChat(store.ownerId)}
                      >
                        <T>Mensaje</T>
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      size="small"
                      fullWidth
                      color="warning"
                      onClick={() => navigate(`/stores/${store.slug}`)}
                    >
                      <T>Ver tienda</T>
                    </Button>
                  </Stack>
                </Box>
              </Popup>
            </Marker>
          ))}

        {/* Marcadores de eventos cercanos */}
        {nearbyEvents.map((event) => (
          <Marker
            key={`event-${event.id}`}
            position={[event.latitude, event.longitude]}
            icon={EVENT_MARKER_ICON}
          >
            <Popup>
              <Box sx={{ p: 1, minWidth: 200 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
                  <EventIcon sx={{ color: "#8e24aa" }} />
                  <Typography variant="subtitle1" fontWeight="bold">
                    {event.title || <T>Sin título</T>}
                  </Typography>
                </Box>
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  📅 {formatEventDate(event.nextDate)}
                </Typography>
                {event.direccion && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 0.5 }}>
                    <LocationOnIcon sx={{ fontSize: 14 }} color="action" />
                    <Typography variant="caption">{event.direccion}</Typography>
                  </Box>
                )}
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                  <T>A {formatDistance(event.distance)} de ti</T>
                </Typography>
                <Button
                  variant="contained"
                  size="small"
                  fullWidth
                  sx={{ bgcolor: "#8e24aa", "&:hover": { bgcolor: "#6a1b9a" } }}
                  onClick={() => navigate(`/events/${event.id}`)}
                >
                  <T>Ver evento</T>
                </Button>
              </Box>
            </Popup>
          </Marker>
        ))}

        {users.filter((user) => !blockedIds.includes(user.id)).map((user) => {
          const isCurrentUser = auth.currentUser && user.id === auth.currentUser.uid;
          const isPublic = user.perfilPublico !== false;
          return (
            <React.Fragment key={user.id}>
              {user.accuracy && (
                <Circle
                  center={[user.latitude, user.longitude]}
                  radius={user.accuracy}
                  pathOptions={{
                    fillColor: user.isActive ? "#4caf50" : "#ff9800",
                    fillOpacity: 0.08,
                    color: user.isActive ? "#4caf50" : "#ff9800",
                    weight: 1,
                  }}
                />
              )}
              <Marker
                position={[user.latitude, user.longitude]}
                icon={
                  new L.DivIcon({
                    html: `
                    <div style="
                      background: ${user.isActive ? "#4caf50" : "#ff9800"};
                      width: 32px;
                      height: 32px;
                      border-radius: 50%;
                      border: 3px solid white;
                      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
                      position: relative;
                      overflow: hidden;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                    ">
                      ${
                        safeHttpUrl(user.profileImageUrl)
                          ? `<img src="${escapeHtml(safeHttpUrl(user.profileImageUrl))}" alt="perfil" style="width:100%;height:100%;object-fit:cover;border-radius:50%;" onerror="this.style.display='none';this.nextElementSibling.style.display='flex';" /><div style="display:none;width:100%;height:100%;align-items:center;justify-content:center;"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg></div>`
                          : '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>'
                      }
                      ${
                        user.currentMood
                          ? `<div style="
                        position: absolute;
                        top: -22px;
                        left: 50%;
                        transform: translateX(-50%);
                        font-size: 18px;
                        filter: drop-shadow(0 1px 2px rgba(0,0,0,0.3));
                      ">${getMoodEmoji(user.currentMood)}</div>`
                          : ""
                      }
                    </div>
                  `,
                    className: "other-user-marker",
                    iconSize: [32, 32],
                    iconAnchor: [16, 16],
                    popupAnchor: [0, -16],
                  })
                }
              >
                <Popup>
                  <Box sx={{ textAlign: "center", p: 1, minWidth: 220 }}>
                    <Avatar
                      src={user.profileImageUrl}
                      sx={{
                        width: 70,
                        height: 70,
                        margin: "0 auto 12px",
                        border: 3,
                        borderColor: user.isActive
                          ? "success.main"
                          : "warning.main",
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 40 }} />
                    </Avatar>
                    <Typography variant="h6" fontWeight="bold" gutterBottom>
                      {(!isPublic && !isCurrentUser) ? (
                        <Button
                          variant="text"
                          color="primary"
                          size="small"
                          onClick={() => navigate(`/user/${user.id}`)}
                          sx={{ textTransform: 'none', fontWeight: 'bold', fontSize: 18, p: 0 }}
                        >
                          {user.displayName}
                        </Button>
                      ) : (
                        user.displayName
                      )}
                    </Typography>
                    {!isPublic && !isCurrentUser ? (
                      <Typography sx={{ mt: 2, fontWeight: 'bold' }}>
                        <T>Perfil privado</T>
                      </Typography>
                    ) : (
                      <>
                        {user.currentMood && (
                          <Typography variant="body2" sx={{ mb: 1 }}>
                            {getMoodEmoji(user.currentMood)}{' '}
                            {MOODS.find((m) => m.value === user.currentMood)?.label}
                          </Typography>
                        )}
                        <Chip
                          label={(() => {
                            if (user.lastUpdated) {
                              const now = new Date();
                              const last = user.lastUpdated;
                              const diff = (now - last) / 1000; // segundos
                              if (diff < 60) {
                                return <T>🟢 En línea</T>;
                              } else {
                                return <T>🟡 Reciente</T>;
                              }
                            }
                            return <T>🟡 Reciente</T>;
                          })()}
                          color={(() => {
                            if (user.lastUpdated) {
                              const now = new Date();
                              const last = user.lastUpdated;
                              const diff = (now - last) / 1000;
                              return diff < 60 ? "success" : "warning";
                            }
                            return "warning";
                          })()}
                          size="small"
                          sx={{ mb: 1 }}
                        />
                        {user.statusMessage && (
                          <Typography
                            variant="caption"
                            display="block"
                            color="text.secondary"
                            sx={{ mb: 1, fontStyle: "italic" }}
                          >
                            "{user.statusMessage}"
                          </Typography>
                        )}
                        {user.distance !== null && (
                          <Typography
                            variant="caption"
                            display="block"
                            sx={{ mb: 1, fontWeight: "bold", color: brandColors.accent }}
                          >
                            <T>📍 A {formatDistance(user.distance)} de ti</T>
                          </Typography>
                        )}
                        {user.lastUpdated && (
                          <Typography
                            variant="caption"
                            display="block"
                            color="text.secondary"
                            sx={{ mb: 1 }}
                          >
                            🕐 {user.lastUpdated.toLocaleTimeString()}
                          </Typography>
                        )}
                        <Stack direction="row" spacing={1}>
                          <Button
                            variant="outlined"
                            size="small"
                            fullWidth
                            startIcon={<ChatIcon />}
                            onClick={() => handleStartDirectChat(user.id)}
                          >
                            <T>Mensaje</T>
                          </Button>
                          <Button
                            variant="contained"
                            size="small"
                            fullWidth
                            onClick={() => navigate(`/user/${user.id}`)}
                          >
                            <T>Ver Perfil</T>
                          </Button>
                        </Stack>
                        <Button
                          variant="text"
                          size="small"
                          fullWidth
                          color="error"
                          onClick={() => handleBlockMapUser(user.id)}
                          sx={{ mt: 1 }}
                        >
                          <T>Bloquear</T>
                        </Button>
                      </>
                    )}
                  </Box>
                </Popup>
              </Marker>
            </React.Fragment>
          );
        })}
      </MapContainer>

      <Dialog
        open={openMoodDialog}
        onClose={() => {
          setOpenMoodDialog(false);
        }}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          <T>¿Qué estás haciendo?</T>
          <IconButton
            onClick={() => {
              setOpenMoodDialog(false);
            }}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 1 }}>
            <FormControl fullWidth>
              <InputLabel><T>Actividad</T></InputLabel>
              <Select
                value={selectedMood}
                onChange={(e) => setSelectedMood(e.target.value)}
                label="Actividad"
              >
                {MOODS.map((mood) => (
                  <MenuItem key={mood.value} value={mood.value}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <span style={{ fontSize: "20px" }}>{mood.icon}</span>
                      <span>{mood.label}</span>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label={<T>Mensaje opcional</T>}
              placeholder="Ej: En el parque Rivadavia, alguien más?"
              value={statusMessage}
              onChange={(e) => setStatusMessage(e.target.value)}
              fullWidth
              multiline
              rows={2}
              inputProps={{ maxLength: 100 }}
              helperText={<T>{statusMessage.length}/100 caracteres</T>}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setOpenMoodDialog(false);
            }}
          >
            <T>Cancelar</T>
          </Button>
          <Button
            onClick={saveMoodStatus}
            variant="contained"
            disabled={!selectedMood}
            startIcon={<SendIcon />}
          >
            <T>Guardar</T>
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={!!locationError}
        autoHideDuration={10000}
        onClose={() => setLocationError(null)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          severity="error"
          onClose={() => setLocationError(null)}
          sx={{ minWidth: 300 }}
        >
          {locationError}
        </Alert>
      </Snackbar>

      <style>{`
        .current-user-marker, .other-user-marker {
          background: none;
          border: none;
        }

        .leaflet-container {
          font-family: 'Roboto', sans-serif;
        }

        .leaflet-popup-content-wrapper {
          background: ${brandColors.backgroundPaper};
          color: ${brandColors.textPrimary};
          border-radius: 16px;
        }

        .leaflet-popup-content {
          margin: 16px;
        }

        .leaflet-popup-tip {
          background: ${brandColors.backgroundPaper};
        }

        .leaflet-popup-close-button {
          color: ${brandColors.textSecondary} !important;
        }

        .leaflet-popup-close-button:hover {
          color: ${brandColors.textPrimary} !important;
        }
      `}</style>
      <MessagesClosedDialog open={messagesClosedOpen} onClose={() => setMessagesClosedOpen(false)} />
    </Box>
  );
};

export default UserMap;